import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';
import { ListContainer } from 'components';
import SentMessagesTable from './SentMessagesTable';
import MessageDetails from './MessageDetails';

const SentMessages = () => {
    const { path } = useRouteMatch();

    return (
        <ListContainer>
            <Switch>
                <Route path={`${path}/details/:id`} component={MessageDetails} />
                <Route path={path} render={() => <SentMessagesTable />} />
            </Switch>
        </ListContainer>
    );
};

export default SentMessages;
